import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import './calendar.scss'
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useTheme } from '../../utils/contexts/ThemeContext';
import interactionPlugin from '@fullcalendar/interaction';
import { Assistance } from '../../utils/models/Assistance';

export type CalendarEvent = {
  title: string;
  date: string;
  allDay?: boolean
  color?: string
  extendedProps?: any
};

interface CalendarProps {
  events: CalendarEvent[]
  onEventClick: (e: Assistance) => void;
  onEventUpdateDate: (e: Assistance) => void;
}

export default function Calendar({ events, onEventClick, onEventUpdateDate }: CalendarProps) {

  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(i18n.language.split('-')[0]);

  const theme = useTheme()

  useEffect(() => {
    const lang = i18n.language?.split('-')[0];
    setLocale(lang);
  }, [i18n.language]);

  const handleEventDrop = (info: any) => {
    const { event } = info;

    const assistance: Assistance = {
      ...event.extendedProps,
      assistance_date: event.start,
    };
    onEventUpdateDate(assistance)
  };

  return (
    <div className={`container h-100 ${theme.theme === 'dark' ? 'dark' : 'light'}`}>
      <FullCalendar
        events={events}
        plugins={[dayGridPlugin, interactionPlugin]}
        editable={true}
        eventDrop={handleEventDrop}
        initialView="dayGridMonth"
        locale={locale}
        firstDay={1}
        headerToolbar={{
          left: 'prev,next',
          center: 'title',
          right: ''
        }}
        titleFormat={(arg) => {
          const nativeDate = new Date(arg.date.marker);
          const formatted = nativeDate.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric',
          });
          return formatted.charAt(0).toUpperCase() + formatted.slice(1);
        }}
        navLinks={false}
        dayMaxEventRows={true}
        fixedWeekCount={false}
        height="100%"
        // dayMaxEventRows={2}
        eventClick={(info) => {
          onEventClick(info.event.extendedProps as Assistance);

          // Si es un click dins del popup de "more", tancarem el popup
          info.jsEvent.preventDefault();
          setTimeout(() => {
            document.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
          }, 0);
        }}
      />
    </div>
  )
}